import { render } from "./ThisQuestion.vue?vue&type=template&id=9e87ef0a&scoped=true"
import script from "./ThisQuestion.vue?vue&type=script&lang=js"
export * from "./ThisQuestion.vue?vue&type=script&lang=js"

import "./ThisQuestion.vue?vue&type=style&index=0&id=9e87ef0a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e87ef0a"]])

export default __exports__